import axios from 'axios';

const API_VERSION_HEADER = process.env.API_VERSION_HEADER || 'v11';
const API_URL = process.env.GATSBY_API_URL || 'https://test-api1.periodica.press/api';
const defaultHeaders = { 'Accept-Version': API_VERSION_HEADER, 'Content-Type': 'application/json' };

export const subscribe = async (email: string, options = {}): Promise<void> => {
  await axios.post(
    `${API_URL}/subscription`,
    {
      email,
      extra_fields: options,
      groups: ['main_list', 'unconfirmed'],
    },
    {
      headers: defaultHeaders,
    }
  );
};
